import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

function NotificationSettings() {
  const { user } = useAuth();
  const [threshold, setThreshold] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchThreshold = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/credit-threshold`, {
          headers: {
            'Authorization': `Bearer ${user.token}`,
            'Content-Type': 'application/json'
          }
        });
        setThreshold(response.data.threshold || '');
      } catch (error) {
        console.error('Error fetching threshold:', error);
      }
    };
    if (user && user.token) {
      fetchThreshold();
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/credit-threshold`, {
        threshold: threshold === '' ? null : parseInt(threshold)
      }, {
        headers: {
          'Authorization': `Bearer ${user.token}`,
          'Content-Type': 'application/json'
        }
      });
      setMessage('Notification settings updated successfully');
      setError('');
    } catch (error) {
      setError('Failed to update notification settings');
      setMessage('');
    }
  };

  return (
    <div>
      <h3>Credit Notification Settings</h3>
      <p>Get notified when your credits fall below a certain threshold.</p>
      {message && <div className="success">{message}</div>}
      {error && <div className="error">{error}</div>}
      <form className="manage-account-form">
        <div className="form-group">
          <label htmlFor="creditThreshold">Credit Threshold</label>
          <input
            id="creditThreshold"
            type="number"
            min="0"
            value={threshold}
            onChange={(e) => setThreshold(e.target.value)}
            placeholder="Enter credit threshold"
          />
          <p className="help-text">Leave empty to disable threshold notifications</p>
        </div>
        <button type="submit" className="manage-account-button" onClick={handleSubmit}>Save Settings</button>
      </form>
    </div>
  );
}

export default NotificationSettings;
